import { createRoot } from "react-dom/client";
import "@fontsource/sora/400.css";
import "@fontsource/sora/600.css";
import "@fontsource/sora/700.css";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Defer analytics initialization to reduce TBT
if (typeof requestIdleCallback !== "undefined") {
  requestIdleCallback(() => import("./lib/analyticsTracker").then(m => m.initTracker()));
} else {
  setTimeout(() => import("./lib/analyticsTracker").then(m => m.initTracker()), 2000);
}
